/**
 * @generated SignedSource<<71f6257051c164dd8913fa2d8a13065a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingTotals_project$data = {
  readonly id: string;
  readonly name: string | null;
  readonly rateCard: {
    readonly currency: string | null;
  } | null;
  readonly budget: number | null;
  readonly budgetType: BUDGET_TYPE | null;
  readonly defaultPeriodBudgetType: PERIOD_BUDGET_TYPE | null;
  readonly invoices: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly status: string | null;
        readonly isImported: boolean | null;
        readonly invoicedWithoutTaxProjectCurrency: number | null;
        readonly paidWithoutTaxProjectCurrency: number | null;
        readonly unpaidWithoutTaxProjectCurrency: number | null;
        readonly dueDay: number | null;
        readonly dueMonth: number | null;
        readonly dueYear: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly timeFinancialNumbers: {
    readonly billableActualTimeAndExpenses: number | null;
  } | null;
  readonly financialNumbers: {
    readonly totalRevenueRecognition: number | null;
    readonly totalActualRevenueRecognition: number | null;
    readonly expenseRevenuePercentage: number | null;
  } | null;
  readonly deliverableTimeFinancialNumbers: ReadonlyArray<{
    readonly deliverableId: number | null;
    readonly billableActualTimeAndExpenses: number | null;
  } | null> | null;
  readonly deliverables: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly price: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly expenseItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly approved: boolean | null;
        readonly billable: boolean | null;
        readonly partOfFixedPrice: boolean | null;
        readonly expenseYear: number | null;
        readonly expenseMonth: number | null;
        readonly expenseDay: number | null;
        readonly price: number | null;
        readonly cost: number | null;
        readonly quantity: number | null;
        readonly deliverable: {
          readonly id: string;
          readonly price: number | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ProjectInvoicingTotals_project";
};
export type ProjectInvoicingTotals_project$key = {
  readonly " $data"?: ProjectInvoicingTotals_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTotals_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v2 = {
  "kind": "Literal",
  "name": "searchQuery",
  "value": {
    "filters": [
      {
        "field": "ROLE",
        "operator": "NOT_IN",
        "value": "Um9sZTotMQ=="
      }
    ]
  }
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableActualTimeAndExpenses",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v5 = [
  (v0/*: any*/),
  (v4/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "expenseItems"
        ]
      }
    ]
  },
  "name": "ProjectInvoicingTotals_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RateCard",
      "kind": "LinkedField",
      "name": "rateCard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budget",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultPeriodBudgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InvoiceTypeConnection",
      "kind": "LinkedField",
      "name": "invoices",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InvoiceType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isImported",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoicedWithoutTaxProjectCurrency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paidWithoutTaxProjectCurrency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unpaidWithoutTaxProjectCurrency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dueDay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dueMonth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dueYear",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "timeFinancialNumbers",
      "args": [
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbers",
      "plural": false,
      "selections": [
        (v3/*: any*/)
      ],
      "storageKey": "financialNumbers(convertToProjectCurrency:true,searchQuery:{\"filters\":[{\"field\":\"ROLE\",\"operator\":\"NOT_IN\",\"value\":\"Um9sZTotMQ==\"}]})"
    },
    {
      "alias": null,
      "args": [
        (v1/*: any*/)
      ],
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalRevenueRecognition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalActualRevenueRecognition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expenseRevenuePercentage",
          "storageKey": null
        }
      ],
      "storageKey": "financialNumbers(convertToProjectCurrency:true)"
    },
    {
      "alias": "deliverableTimeFinancialNumbers",
      "args": [
        (v1/*: any*/),
        {
          "kind": "Literal",
          "name": "groupBy",
          "value": [
            "DELIVERABLE"
          ]
        },
        (v2/*: any*/)
      ],
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "groupedFinancialNumbers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deliverableId",
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": "groupedFinancialNumbers(convertToProjectCurrency:true,groupBy:[\"DELIVERABLE\"],searchQuery:{\"filters\":[{\"field\":\"ROLE\",\"operator\":\"NOT_IN\",\"value\":\"Um9sZTotMQ==\"}]})"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        }
      ],
      "concreteType": "DeliverableTypeConnection",
      "kind": "LinkedField",
      "name": "deliverables",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DeliverableTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeliverableType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v5/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "deliverables(first:10000)"
    },
    {
      "alias": "expenseItems",
      "args": null,
      "concreteType": "ExpenseItemTypeConnection",
      "kind": "LinkedField",
      "name": "__Project_expenseItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseItemTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExpenseItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "approved",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "billable",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "partOfFixedPrice",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expenseYear",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expenseMonth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expenseDay",
                  "storageKey": null
                },
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cost",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "quantity",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DeliverableType",
                  "kind": "LinkedField",
                  "name": "deliverable",
                  "plural": false,
                  "selections": (v5/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};
})();

(node as any).hash = "39b1e3548f4f535dfdb6c3d7e1ebc22c";

export default node;
